export interface AuthConfig {
  /** Origin of StructuraMatrix.Auth, without a trailing slash. */
  readonly baseUrl: string
  /** This site's key under Apps in the Auth service's appsettings.json. */
  readonly appId: string
}

const APP_ID_PATTERN: RegExp = /^[a-z0-9-]{1,64}$/

function requireEnv(name: string, value: string | undefined): string {
  if (value === undefined || value.trim() === '') throw new Error(`Reading the account-service config failed: ${name} is not set — add it to .env.${import.meta.env.MODE}`)
  return value.trim()
}

function readBaseUrl(): string {
  const raw: string = requireEnv('VITE_AUTH_URL', import.meta.env.VITE_AUTH_URL)
  const url: URL = new URL(raw)
  if ((url.protocol !== 'https:' && url.protocol !== 'http:') || url.pathname !== '/') throw new Error(`Reading the account-service config failed: VITE_AUTH_URL must be a bare http(s) origin, got ${JSON.stringify(raw)}`)
  return url.origin
}

function readAppId(): string {
  const appId: string = requireEnv('VITE_AUTH_APP_ID', import.meta.env.VITE_AUTH_APP_ID)
  if (!APP_ID_PATTERN.test(appId)) throw new Error(`Reading the account-service config failed: VITE_AUTH_APP_ID must be a lowercase app key, got ${JSON.stringify(appId)}`)
  return appId
}

export const authConfig: AuthConfig = { baseUrl: readBaseUrl(), appId: readAppId() }
